import { useListView } from '../../core/ListViewProvider'
import { useAuth } from '../../../../../auth'
import { temVinculoMedicoAtivo } from 'app/modules/auth/core/vinculos'
import { AvaliacoesPendentesListGrouping } from './AvaliacoesPendentesListGrouping'
import { AvaliacoesPendentesListSearchComponent } from './AvaliacoesPendentesListSearchComponent'

export const AvaliacoesPendentesListHeader = () => {
  const { selected } = useListView()
  const { currentUser } = useAuth()
  const isMedico = temVinculoMedicoAtivo(currentUser?.vinculos)

  return (
    <div className='card-header border-0 pt-6'>
      <AvaliacoesPendentesListSearchComponent
        actions={isMedico && selected.length > 0 ? <AvaliacoesPendentesListGrouping /> : undefined}
      />
    </div>
  )
}
